import PayAtTablePage from './PayAtTablePage';

export default PayAtTablePage;
